import React from 'react'
import styled from 'styled-components'
import { Field, FormSpy } from 'react-final-form'

function RadioField({ input, label }) {
  return (
    <RadioWrapper>
      <input type="radio" id={`${input.name}-${input.value}`} {...input} />
      <label htmlFor={`${input.name}-${input.value}`}>{label}</label>
    </RadioWrapper>
  )
}

export default function RadioGroup({ name, label, validate, options = [] }) {
  return (
    <span>
      {options.map(({ label: optionLabel, value }) => (
        <Field
          key={`${name}-${value}`}
          name={name}
          type="radio"
          value={String(value)}
          validate={validate}>
          {props => <RadioField name={name} label={optionLabel} {...props} />}
        </Field>
      ))}
      <FormSpy subscription={{ error: true, touched: true }}>
        {props => {
          const meta = props.form.getFieldState(name)
          if (meta && meta.error && meta.touched) {
            return <span>{meta.error}</span>
          }
          return null
        }}
      </FormSpy>
    </span>
  )
}

const RadioWrapper = styled.div`
  display: inline-block;
  margin-right: 30px;
  label { padding-left: 7px;   cursor: pointer; }
`
